import React from 'react';

const BetBleLink = ({ clickHandler }) => {
  return (
    <a className="btn_betting" onClick={clickHandler}>베팅하기</a>
  );
};

export default BetBleLink;
